import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function MarriageCertificateListingContent({
  handleAddModal,
  handleViewImage,
  handleEdit,
  marriageCertificateId,
  showMarriageCertificate,
  marriageCertificateInfo,
}) {
  useEffect(() => {
    if (_.isEmpty(marriageCertificateId)) return;
    showMarriageCertificate(marriageCertificateId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(marriageCertificateId)) return;
    showMarriageCertificate(marriageCertificateId);
  }, [marriageCertificateId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add &nbsp;&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(marriageCertificateInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Record Information</h3>
                <div>
                  <button
                    type="button"
                    className="btn btn-warning mr-2"
                    onClick={handleEdit(marriageCertificateInfo)}
                  >
                    Edit Record
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2"
                    onClick={handleViewImage(marriageCertificateInfo, 'front_page')}
                  >
                    Show Front
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary "
                    onClick={handleViewImage(marriageCertificateInfo, 'back_page')}
                  >
                    Show Back
                  </button>
                </div>
              </div>
              <hr />
              <div className="mt-4">
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <th className="table-title">Registry Number:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.registry_number'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Name of Man/Husband</th>
                        </tr>
                        <tr>
                          <th className="table-title">First Name:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.husband_first_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Middle Name:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.husband_middle_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Last Name:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.husband_last_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Extension Name:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.husband_extension_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Name of Lady/Wife</th>
                          <td>&nbsp;</td>
                        </tr>
                        <tr>
                          <th className="table-title">First Name:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.wife_first_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Middle Name:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.wife_middle_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Last Name:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.wife_last_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Extension Name:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.wife_extension_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Date of Marriage:</th>
                          <td>
                            {_.get(
                              marriageCertificateInfo,
                              'attributes.date_marriage'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Volume:</th>
                          <td>
                            {_.get(marriageCertificateInfo, 'attributes.volume') ||
                              '--'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

MarriageCertificateListingContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleViewImage: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  showMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
  marriageCertificateInfo: PropTypes.instanceOf(Object).isRequired,
  marriageCertificateId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  marriageCertificateInfo: _.get(api, `${c.GET_SINGLE_MARRIAGE_CERTIFICATE}.item`) || {},
  marriageCertificateId: _.get(match, 'params.marriageCertificateId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MarriageCertificateListingContent);
